module.exports = __webpack_public_path__ + "img/ichLogo.6538d37d.png";